import { withColor } from "../../../ui/uiText";
import { Piece } from "../../actors/Actor";
import Colors from "../../Colors";

export const buildLetterString = (
  available: string[],
  used: string[],
  max = 0
) => {
  const played = used.reduce((r, p) => {
    if (p) {
      if (r[p]) {
        r[p] += 1;
      } else {
        r[p] = 1;
      }
    }
    return r;
  }, {} as Record<string, number>);

  const colorLetters = available.map((l) => {
    if (0 < played[l]) {
      played[l] = played[l] - 1;
      return withColor(Colors.AQUA_2, l);
    } else {
      return withColor(Colors.EGGSHELL, l);
    }
  });

  for (let i = colorLetters.length - 1; i < max; i++) {
    colorLetters.push(" ");
  }
  return colorLetters.join("");
};

export const buildLetterStringPieces = (
  available: string[],
  used: Piece[],
  max = 0
) => {
  const played = used.reduce((r, p) => {
    if (p.ch) {
      if (r[p.ch]) {
        r[p.ch] += 1;
      } else {
        r[p.ch] = 1;
      }
    }
    return r;
  }, {} as Record<string, number>);

  const colorLetters = available.map((l) => {
    if (0 < played[l]) {
      played[l] = played[l] - 1;
      return withColor(Colors.AQUA_2, l);
    } else {
      return withColor(Colors.EGGSHELL, l);
    }
  });

  for (let i = colorLetters.length - 1; i < max; i++) {
    colorLetters.push(" ");
  }
  return colorLetters.join("");
};

export const buildFixedTextPromptString = (letters: string[], max: number) => {
  const padCount = max - letters.length;
  let pad = "";
  if (padCount) {
    if (max === 1) {
      pad = "_";
    } else {
      const padValues = Array(padCount - 1).fill("_");
      pad = `${withColor(Colors.RED, ">")}${padValues.join("")}`;
    }
  }
  return `${letters.join("")}${pad}`;
};
